export const loadLocalState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        /*add better logging for errors*/
        return undefined;
    }
};

export const clearLocalState = () => {
    try {
        if (localStorage.getItem('state') !== null) {
            localStorage.clear();
        }
    } catch (err) {
        console.log(err);
    }
};
export const saveLocalState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {
            console.log(err);
    }
};

export const loadSessionState = () => {
    try {
        const serializedState = sessionStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        /*add better logging for errors*/
        return undefined;
    }
};

export const saveSessionState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('state', serializedState);
    } catch (err) {
            console.log(err);
    }
};

export const clearSessionState = () => {
    try {
        if (sessionStorage.getItem('state') !== null) {
            sessionStorage.clear();
        }
        localStorage.clear();
    } catch (err) {
        console.log(err);
    }
};